import React, { useState } from 'react';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import styles from './student-cb-alert.css';

const StudentCBAlert = (props) => {
  const [showModal, setShowModal] = useState(true);

  const { uiConfig } = props;
  const onClose = () => {
    setShowModal(false);
  };

  return showModal ? (
    <ConfirmDialog
      size="small"
      title="Announcement"
      topBarClassName={styles.student_cb_alert_top_bar}
      onClose={onClose}
      onSuccess={onClose}
      content={{
        btnPrimary: 'Close',
      }}
    >
      <div className="flex">
        <Icon
          className="m-auto"
          id="notification_bell"
          height="80"
          width="80"
        />
      </div>
      <h2 className="text-center leading-normal">{uiConfig?.title}</h2>
      <p className="text-left">
        <div dangerouslySetInnerHTML={{ __html: uiConfig?.body }} />
      </p>
    </ConfirmDialog>
  ) : null;
};

export default StudentCBAlert;
